// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
  background-color: #1a3a5c;
  width: 100%;
  box-sizing: border-box;
}

/* ── Zona superior ── */
.Footer_footerTop__AqnA2 {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 40px;
  padding: 56px 60px 40px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* Columna logo */
.Footer_colBrand__cVAjK {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.Footer_logoImg__YKKZV {
  width: 150px;
  filter: brightness(0) invert(1);
}

.Footer_brandDesc__nWLBG {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  margin: 0;
  max-width: 280px;
}

/* Columnas de links */
.Footer_col__uMvMM {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.Footer_colTitle__QZ36R {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  text-transform: uppercase;
}

.Footer_colLinks__BFd94 {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Footer_colLink__nUzfi {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.Footer_colLink__nUzfi:hover {
  color: #ffffff;
}

/* ── Zona inferior ── */
.Footer_footerBottom__XPvsq {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 60px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.Footer_footerBottom__XPvsq span {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .Footer_footerTop__AqnA2 {
    grid-template-columns: 1fr 1fr;
    padding: 40px 24px 32px;
  }

  .Footer_footerBottom__XPvsq {
    padding: 16px 24px;
  }
}

@media (max-width: 500px) {
  .Footer_footerTop__AqnA2 {
    grid-template-columns: 1fr;
  }
}

.Footer_footer_container__fXji8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Footer_footer_social__VPy3G {
  margin-bottom: 10px;
  display: flex;
}

.Footer_footer_social__VPy3G a {
  color: white;

  font-size: 20px;
  margin: 0 10px;
  transition: color 0.3s;
}

.Footer_footer_social__VPy3G a:hover {
  color: #500075;
}

.Footer_footer_text__5zaph p {
  margin-top: 10px;
  color: gray;
}

.Footer_footer_icon__-4iCi {
  vertical-align: middle;
}
.Footer_footer_links__qYt7n {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 1em;
}
.Footer_footer_link__kPYRg {
  color: gray;

  text-decoration: none;
}

.Footer_footer_link__kPYRg:hover {
  text-decoration: underline;
  color: white;
}

.Footer_footer_link_mobile__2\\+E9y {
  color: gray;

  text-decoration: none;
}

.Footer_footer_link_mobile__2\\+E9y:hover {
  text-decoration: underline;
  color: white;
}
.Footer_book_reclam__MYnvh img {
  width: 60px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .Footer_footer_link_mobile__2\\+E9y {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;;EAEZ,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;;EAEX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".footer {\n  background-color: #1a3a5c;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ── Zona superior ── */\n.footerTop {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr 1fr 1fr;\n  gap: 40px;\n  padding: 56px 60px 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n/* Columna logo */\n.colBrand {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.logoImg {\n  width: 150px;\n  filter: brightness(0) invert(1);\n}\n\n.brandDesc {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.6;\n  margin: 0;\n  max-width: 280px;\n}\n\n/* Columnas de links */\n.col {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.colTitle {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.colLinks {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.colLink {\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.2s;\n}\n\n.colLink:hover {\n  color: #ffffff;\n}\n\n/* ── Zona inferior ── */\n.footerBottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 20px 60px;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.footerBottom span {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* ── Responsive ── */\n@media (max-width: 900px) {\n  .footerTop {\n    grid-template-columns: 1fr 1fr;\n    padding: 40px 24px 32px;\n  }\n\n  .footerBottom {\n    padding: 16px 24px;\n  }\n}\n\n@media (max-width: 500px) {\n  .footerTop {\n    grid-template-columns: 1fr;\n  }\n}\n\n.footer_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.footer_social {\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.footer_social a {\n  color: white;\n\n  font-size: 20px;\n  margin: 0 10px;\n  transition: color 0.3s;\n}\n\n.footer_social a:hover {\n  color: #500075;\n}\n\n.footer_text p {\n  margin-top: 10px;\n  color: gray;\n}\n\n.footer_icon {\n  vertical-align: middle;\n}\n.footer_links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 1em;\n}\n.footer_link {\n  color: gray;\n\n  text-decoration: none;\n}\n\n.footer_link:hover {\n  text-decoration: underline;\n  color: white;\n}\n\n.footer_link_mobile {\n  color: gray;\n\n  text-decoration: none;\n}\n\n.footer_link_mobile:hover {\n  text-decoration: underline;\n  color: white;\n}\n.book_reclam img {\n  width: 60px;\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n  .footer_link_mobile {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"footerTop": `Footer_footerTop__AqnA2`,
	"colBrand": `Footer_colBrand__cVAjK`,
	"logoImg": `Footer_logoImg__YKKZV`,
	"brandDesc": `Footer_brandDesc__nWLBG`,
	"col": `Footer_col__uMvMM`,
	"colTitle": `Footer_colTitle__QZ36R`,
	"colLinks": `Footer_colLinks__BFd94`,
	"colLink": `Footer_colLink__nUzfi`,
	"footerBottom": `Footer_footerBottom__XPvsq`,
	"footer_container": `Footer_footer_container__fXji8`,
	"footer_social": `Footer_footer_social__VPy3G`,
	"footer_text": `Footer_footer_text__5zaph`,
	"footer_icon": `Footer_footer_icon__-4iCi`,
	"footer_links": `Footer_footer_links__qYt7n`,
	"footer_link": `Footer_footer_link__kPYRg`,
	"footer_link_mobile": `Footer_footer_link_mobile__2+E9y`,
	"book_reclam": `Footer_book_reclam__MYnvh`
};
export default ___CSS_LOADER_EXPORT___;
